export function filterUndefined<T>(list: (T | undefined)[]) {
  return list.filter((item) => item !== undefined) as T[];
}

export function filterNull<T>(list: (T | null)[]) {
  return list.filter((item) => item !== null) as T[];
}

// typescript magic to filter discriminate unions, based on https://stackoverflow.com/a/59054248/953222
export function isType<K extends PropertyKey, V extends string | number | boolean>(key: K, value: V) {
  return <T extends Record<K, any>>(obj: T & Record<K, V extends T[K] ? T[K] : V>): obj is Extract<T, Record<K, V>> => obj[key] === value;
}

export type Operator = ">" | ">=" | "<" | "<=" | "!=" | "==";

/**
 * Simple binary comparison
 */
export function compare(value1: undefined | any, op: Operator, value2: undefined | any) {
  switch (op) {
    case ">":
      return typeof value1 !== "undefined" && typeof value2 !== "undefined" && value1 > value2;
    case ">=":
      return typeof value1 !== "undefined" && typeof value2 !== "undefined" && value1 >= value2;
    case "<":
      return typeof value1 !== "undefined" && typeof value2 !== "undefined" && value1 < value2;
    case "<=":
      return typeof value1 !== "undefined" && typeof value2 !== "undefined" && value1 <= value2;
    case "!=":
      return typeof value1 !== "undefined" && typeof value2 !== "undefined" && value1 !== value2;
    case "==":
      return typeof value1 !== "undefined" && typeof value2 !== "undefined" && value1 === value2;
  }
}
